<template>
  <li v-if="videoID !== null" class="rubric-option"
    @click="videoID > 0 ? scoreRubric(val) : {}"
    :class="{ 'is-active': selected, disabled: true }"
    >
    <section>
      <h3 v-if="!editing" class="title is-5">{{ header }}</h3>
      <input v-else
        type="text"
        class="input"
        placeholder="Update title..."
        v-model="header"
        />
      <p v-if="!editing">{{ desc }}</p>
      <textarea v-else
        v-textautosize
        type="text"
        class="textarea"
        placeholder="Update title..."
        v-model="desc"
        />
    </section>

    <div class="selected-container">
      <input
        type='radio'
        :disabled="false"
        :checked="selected"
      />
    </div>

  </li>
  <li v-else class="rubric-option"
    :class="{ 'is-active': selected, disabled: true }"
    >
    <section>
      <h3 class="title is-5">{{ header }}</h3>
      <p>{{ desc }}</p>
    </section>

    <div class="selected-container">
      <input
        type='radio'
        :disabled="false"
        :checked="selected"
      />
    </div>

  </li>
</template>

<script>

import store from '../store.js'

import { textautosize } from '../directives.js'

import {
  addScoreToComment
} from '../actionTypes'

export default {
  name: 'RubricBox',
  props: {
    selected: {
      type: Boolean,
      required: false,
    },
    header: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
      required: true,
    },
    val: {
      type: Number,
      required: true,
    },
    tagID: {
      type: Number,
      required: true,
    },
    commentID: {
      required: false,
    },
    videoID: {
      required: false,
    },
    editing: {
      type: Boolean,
      required: true,
    }
  },
  directives: {
    textautosize,
  },
  methods: {
    async scoreRubric (value) {
      const { videoID, commentID, tagID } = this
      await store.dispatch(addScoreToComment, { value, videoID, tagID, commentID })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../_variables.scss';

.rubric-option {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-grow: 1;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  padding: 1.25rem;
  white-space: initial;
  cursor: pointer;
  transform: translateY(0);
  transition: all 0.2s;
  // this will override the 'all' with only the properties we want to change
  transition-property: transform, box-shadow, background;
  will-change: transform, box-shadow, background;

  // don't change background on hover if disabled
  &:not(.disabled):hover {
    background-color: $cloud;
  }

  &:active {
    transform: translateY(2px);
  }

  &:last-child {
    margin-right: 0;
  }

  &.is-active {
    box-shadow: rgba(10, 10, 10, 0.1) 0px 9px 18px 0px, $teal 0px 0px 0px 4px;
    transform: translateY(-2px);
    background-color: gainsboro;
  }

}

.disabled.rubric-option {
  cursor: default;
  &:active:not(.is-active) {
    transform: none;
  }

  &:hover:not(.is-active) {
    background-color: inherit;
  }
}

.selected-container {
  display: none;
  justify-content: center;
  padding: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// RubricBox.vue?80b0ef18